import { Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PrimaryButton, Sticky } from "@fluentui/react";
import { FaSpinner } from 'react-icons/fa';
// FormSubmission.css, Submission.scss and popupModal.css are loaded globally in
// src/index.js (single source of truth). The duplicate imports that were here
// are removed — webpack deduped them anyway.
import { useForm } from "react-hook-form";
import { useState, useRef } from "react";
import { useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import authAxios from "../../services/Api";
import apiFieldAxios from "../../services/ApiFieldValue";
import { BASE_API_URL } from "../../services/config";
import { toast } from "react-toastify";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
// import evaluate from "simple-evaluate";
import MapNewModal from "./MapNewModal";
import useModal from "./useModal";
import Resizer from "react-image-file-resizer"; // image resizer
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useLoading } from "../../shared/Loader/LoadingContext";
import ImagePopup from "./ImagePopup";
import ReactSelect from "react-select";
import Cookies from "js-cookie";
import SVGIcon from "../../components/DynamicIcon";
import { useLocation } from "react-router-dom";
import { IMAGE } from "../../services/config"; // import image api
import ConfirmModal from "../../shared/ConfirmModal/ConfirmModal";
import PopupDynamicForm from "./PopupDynamicForm";
import { showSuccessToast } from "../../shared/CustomToast/customtoast";
import CustomModal from "../../shared/CustomModal/CustomModal";
import MultiselectCheckboxes from 'react-multiselect-checkboxes';
import { create, all, to } from 'mathjs';
import dataUploadAuthAxios from "../../services/DatauploadApi";

    

const FormSubmissionHeader = ({
  ModalIsOpen,
  setIsModelPopup,
  actionID,
  name_id,
  formList,
  selectedForm,
  handleOpen,
  handleTitleClose,
  handleSelect,
  isTitleOpen,
  dropdownRef,
  displayName,
  allsubFormArray,
  submittedBy,
  isPrint,
  isPrintLoading,
  handlePrint,
  navigateTo,
  navigateFrom,
  dashboardActiveTab,
  showPrevious,
  handleFormPrevious,
  handleSubmit,
  onSubmit1,
  isLoadingBtn,
  submit_button,
  isSaveAndNew,
  handleSaveAndNew,
  showNext,
  handleFormNext,
  next_button,
  showButtonShow,
  showDeleteButton,
  setShowDeleteModal,
  isApproved,
  showApprovePermission,
  handleRejectConfirm,
  handleApprovalConfirm,
  isSecondApproved,
  showSecondApprovePermission,
  handleSecondRejectConfirm,
  handleSecondApprovalConfirm
}) => {
  return (      
        <div className="form-submission-header-div" style={{ minHeight: '50px', alignItems: 'center', paddingTop: '0px', paddingBottom: 0}}>
          <IconButton
            variant="contained"
            style={{ padding: "0px" }}
            title="Back"
            aria-label="Back"
            onClick={() => {
              if (ModalIsOpen) {
                setIsModelPopup(false);
              } else {
                if (actionID && actionID !== "Dashboard") {
                  navigateTo(`/actiontable_list/${actionID}`);
                }
                else if(navigateFrom==='dashboard'){
                    navigateTo("/dashboard",{ state: { dashboardActiveTab } });
                    
                  } else {
                  navigateTo(`/formsub/${name_id}`);
                }
              }
            }}
          >
            {" "}
            <SVGIcon name="backIcon" width={24} height={24} />
          </IconButton>
          <div className="form_submission_header_container_new">
            {formList.length == 0 && <span className="form_submission_header">{displayName}</span>}
            {formList.length > 0 &&
              <>
                <span>
                  <div className={`custom-dropdown ${isTitleOpen ? 'open' : ''}`} ref={dropdownRef} onClick={handleOpen}>
                    <div className="selected-form">
                      {selectedForm ? formList.find(form => form._id === selectedForm).form_name : ''} <span><SVGIcon
                        name="arrowDown"
                        width={30}
                        height={30}
                      /></span>
                    </div>
                    <div className="dropdown-options" onClick={handleTitleClose}>
                      <div>
                        {formList.map((form) => (
                          <div
                            key={form.id}
                            className={`form_submission_header_dropdown ${selectedForm === form._id ? 'submission-page-selected' : ''}`}
                            onClick={() => handleSelect(form._id)}
                          >
                            {form.isSubmitted === 1 && <SVGIcon name="submitComplte" width={12} height={9} className="custom-icon" />} {" "}
                            {form.form_name}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
  
                </span>
                <span className="submission-page-count">Total:{allsubFormArray.length}</span>
              </>
  
            }
            {isPrint && (
              <div onClick={() => handlePrint(true, isPrint)} disabled={isPrintLoading} className="printButton" title="Print" style={{ top: '.8rem' }}>
                {/* <img
                  className="mr-2"
                  alt=""
                  src={require("../../assets/img/print-icon.webp")}
                  loading="lazy" /> */}
                <SVGIcon name="PDFprintIcon" width={45} height={32} />
              </div>
            )}
            {/* <span className="form_submission_submittedBy">
              {formList.length > 0 && <span className="submission-page-count">Total:{allsubFormArray.length}</span>}{"  "}{submittedBy && (<span style={{ opacity: "0.3" }}>Submitted By {submittedBy}</span>)}
            </span> */}
  
          </div>
                              <div className={!ModalIsOpen ? "form_button_new_row fixed-form_button_new_row" : "form_button_new_row"}>
                        {showPrevious && (
                          <PrimaryButton
                            className="form_previous_btn"
                            type="button"
                            onClick={handleFormPrevious}
                          >
                            <NavigateBeforeIcon />
                            Previous
                          </PrimaryButton>
                        )}
                        <PrimaryButton
                          className="form_cancel_btn"
                          text="Cancel"
                          onClick={() => {
                            if (ModalIsOpen) {
                              setIsModelPopup(false);
                            } else {
                              if (actionID && actionID !== "Dashboard") {
                                navigateTo(`/actiontable_list/${actionID}`)
                              } 
                              else if(navigateFrom==='dashboard'){
                                  navigateTo("/dashboard",{ state: { dashboardActiveTab } });
                                  
                                }else {
                                navigateTo(`/formsub/${name_id}`);
                              }
                            }
                          }}
                        ></PrimaryButton>
                        {showDeleteButton && (
                          <PrimaryButton
                            className="form_popup_btn_delete ml-2 btn-alignment"
                            text="Delete"
                            onClick={() => setShowDeleteModal(true)}
                          ></PrimaryButton>
                        )}
                        {!showNext && !showButtonShow && (
                          <PrimaryButton
                            className="form_btn_margin btn-alignment"
                            text={(isLoadingBtn && !isSaveAndNew) ? "Saving..." : submit_button}
                            disabled={isLoadingBtn}
                            onClick={handleSubmit(onSubmit1)}
                          >
                            {(isLoadingBtn && !isSaveAndNew) && (
                              <i
                                className="fa fa-refresh fa-spin"
                                style={{ marginRight: "5px" }}
                              />
                            )}
                          </PrimaryButton>
                        )}
                        {/* ======= */}
                        {!showNext && !showButtonShow && !ModalIsOpen && (<PrimaryButton
                          className="form_btn_margin btn-alignment"
                          text={isSaveAndNew ? "Saving..." : "Save & New"}
                          disabled={isSaveAndNew}
                          onClick={handleSubmit(handleSaveAndNew)}
                        >
                          {isSaveAndNew && (
                            <i
                              className="fa fa-refresh fa-spin"
                              style={{ marginRight: "5px" }}
                            />
                          )}
                        </PrimaryButton>)}
                        {showNext && (
                          <PrimaryButton
                            className="form_btn_margin btn-alignment"
                            type="button"
                            text={(isLoadingBtn && !isSaveAndNew) ? "Saving..." : "Save & Close"}
                            disabled={isLoadingBtn}
                            onClick={() => {
                              const parameter = "Save"; // Define your parameter here
                              handleSubmit(() => handleFormNext(parameter))();
                            }}
                            title="Save & Close"
                          >
                          </PrimaryButton>
                        )}
                        {isApproved !== undefined &&
                          isApproved !== null &&
                          isApproved === -1 &&
                          !showNext &&
                          showApprovePermission && (
                            <>
                              <PrimaryButton
                                className="form_reject_btn btn-alignment"
                                onClick={handleRejectConfirm}
                              >
                                Reject
                              </PrimaryButton>
  
                              <PrimaryButton
                                className="form_approve_btn btn-alignment"
                                onClick={handleApprovalConfirm}
                              >
                                <img
                                  src={require("../../assets/img/approvetickicon.webp")}
                                  alt=""
                  loading="lazy" />
                                Approve
                              </PrimaryButton>
                            </>
                          )}
                        {showNext && (
                          <PrimaryButton
                            className="form_sub_next_btn"
                            // type="submit"
                            title={next_button}
                            disabled={isLoadingBtn}
                            onClick={handleSubmit(handleFormNext)}
                            text={next_button}
                          >
                            <NavigateNextIcon />
                          </PrimaryButton>
                        )}
                         {isSecondApproved !== undefined &&
                          isSecondApproved !== null &&
                          isSecondApproved === -1 &&
                          isApproved === 1 &&
                          !showNext &&
                          showSecondApprovePermission && (
                            <>
                              <PrimaryButton
                                className="form_reject_btn btn-alignment"
                                onClick={handleSecondRejectConfirm}
                              >
                                Reject
                              </PrimaryButton>
  
                              <PrimaryButton
                                className="form_approve_btn btn-alignment"
                                onClick={handleSecondApprovalConfirm}
                              >
                                <img
                                  src={require("../../assets/img/approvetickicon.webp")}
                                  alt=""
                  loading="lazy" />
                                Approve
                              </PrimaryButton>
                            </>
                          )}
                         
                        {/* {showNext && (
                          <PrimaryButton
                            className="form_sub_next_btn"
                            // type="submit"
                            title={next_button}
                            disabled={isLoadingBtn}
                            onClick={handleSubmit(handleFormNext)}
                            text={next_button}
                          >
                            <NavigateNextIcon />
                          </PrimaryButton>
                        )} */}
                      </div>
                </div>
        
         );
};

export default FormSubmissionHeader;